import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BiometricLog, BiometricLogCreate, BiometricLogFilter } from '../data/biometricLog';

export function createBiometricLogService(client: AxiosInstance) {
  return createCrudService<BiometricLog, BiometricLogCreate, BiometricLogFilter>(
    client,
    '/hrm/BiometricLog',
    'id',
  );
}

export type BiometricLogService = CrudService<BiometricLog, BiometricLogCreate, BiometricLogFilter>;
